import { render } from "./PersonHeader.vue?vue&type=template&id=d28b02b0&scoped=true"
import script from "./PersonHeader.vue?vue&type=script&lang=js"
export * from "./PersonHeader.vue?vue&type=script&lang=js"

import "./PersonHeader.vue?vue&type=style&index=0&id=d28b02b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d28b02b0"]])

export default __exports__